import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  Fragment,
  useContext,
} from 'react'
import { connect } from 'react-redux'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import { authorization } from 'Module/Auth/Auth'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { RosterViewWrapper } from 'Components/Campaigns/RosterView/RosterViewWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import {
  FILTER_MAP_DENSITY_ENUM,
  MISSION_ENUM_TYPES,
  MISSION_STATUS_ENUM,
} from './../../../shared/constants'
import { deleteMissions } from './../../../Reducers/Mission/actions'
import { showReduxModal, hideReduxModal } from './../../../Reducers/UI/actions'
import { UNBOOK_OPTIONS } from '../../../constants'
import {
  getInitialOverlaysMapFromMissions,
  getBreadcrumbs,
  mergeAreaDataToTheMission,
  getMissionsUpdateResult,
  mergeInitialOverlaysData,
  mergeMissionsData,
  // mergeVisibleOverlaysData,
  getMissionsDeletionData,
  NON_STARTED_STATUSES,
  validateOverlaySave,
} from '../util'
import DrawMap from '../../../Components/DrawMap/container/DrawMap'
import { getNumberOfHouseholdsAndDensityForMissions } from '../../../Utils/Mission'
import DetailsSection from '../../../Components/DetailsSection/DetailsSection'
import BreadcrumbsRenderer from '../../../Components/BreadcrumbsRenderer/BreadcrumbsRenderer'
import MissionsControls from '../../../Components/MissionsControls/MissionsControls'
import { SelectDashboard } from '../../../Components/Form/SelectDashboard'
import {
  getEndOfWeek,
  formatToLocalDate,
} from '../../../shared/libraries/utils/date'
import LetterboxMissionsTable from '../blocks/LetterboxMissionsTable/container/LetterboxMissionsTable'
import { convertArrayToHashMap } from '../../../shared/libraries/dataSets'
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator'
import {
  getPostcodesForBoundaries,
  createOverlayName,
} from '../../../Utils/Map'
import {
  createMissions,
  updateMissionNormalized,
} from '../../../Module/graphQL'
import { apiClient } from '../../../Module/API/Client'
import { getFeatureFromOverlay } from '../../BuilderMap/util'
import { getDetailsItems } from '../../../Components/DetailsSection/utils'
import Checkbox from '@material-ui/core/Checkbox'
import PostcodesSearch from '../../../Components/PostcodesSearch/component/PostcodesSearch'
import BulkPostcodeSearch from '../../../Components/BulkPostcodeSearch'
import BulkActions from '../../../Components/BulkActions'
import {
  getShowDeleteAllNonStartedModalText,
  onPublishDraftMissions,
  onSetDraftMissionsReadyToPublish,
} from '../../../Components/MissionsControls/utils'
import BulkEditMissionModalBody from '../../../Components/BulkActions/blocks/BulkEditMissionModalBody'
import SetMeetingPointModal from '../../../Components/BulkActions/blocks/SetMeetingPointModal'

import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import { Typography } from '@material-ui/core'
import InlineSelect from '../../../Components/Form/SelectDashboard/types/InlineSelect/InlineSelect'
import ConfirmDialog from '../../../Components/ConfirmDialog/ConfirmDialog'
import { handleConfirmationDialog } from '../../City/Page/Ambasadors/EmailPipelineView/utils'
import { calculateTimeOfDay } from '../../../Utils/Mission'
import { generateRandomColor } from '../../../Utils/Misc'
import { SnackBarContext } from 'Components/SnackBar'

const isClient = () => authorization.isClientRole()

// Base key for the persisted mission selection. It MUST be scoped per
// city-plan (see localStorageKey below) — otherwise a selection saved on one
// city-plan's missions page hides missions on every other page.
const localStorageKeyBase = 'd2dLetterboxSelectedMissionsIds'

const LetterboxMissions = props => {
  const {
    showReduxModal,
    city: {
      country: { code: countryCode, currencySign },
      timezone,
    },
    cityPlan,
  } = props

  // Scope the saved-selection key to this city-plan so one page's selection
  // can't hide another page's missions.
  const localStorageKey = `${localStorageKeyBase}:${cityPlan && cityPlan.id}`
  const [processedMissionsMap, setProcessedMissionsMap] = useState({})
  const [initialOverlaysMap, setInitialOverlaysMap] = useState({})
  const [map, setMap] = useState(false)

  const [initialDataLoaded, setInitialDataLoaded] = useState(false)
  const [unbookReason, setUnbookReason] = useState(UNBOOK_OPTIONS[0].value)
  const [visibleOverlaysMap, setVisibleOverlaysMap] = useState(() => {
    // Initialize with all missions visible if we have them
    if (cityPlan.missions && cityPlan.missions.length > 0) {
      return cityPlan.missions.reduce((acc, { id }) => {
        acc[id] = true
        return acc
      }, {})
    }
    return {}
  })
  const processedMissionsMapRef = useRef({})
  const [selectedFilter, setSelectedFilter] = useState(
    FILTER_MAP_DENSITY_ENUM.ALL,
  )
  const [densityFilterLoaded, setDensityFilterLoaded] = useState(false)
  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })
  const [postcodesFromSearch, setPostcodesFromSearch] = useState([])
  const [missionsToSetMeetingPoint, setMissionsToSetMeetingPoint] = useState([])
  const [filteredMissionsIds, setFilteredMissionsIds] = useState([])
  const [isFilterApplied, setIsFilterApplied] = useState(false)

  const runSnackBar = useContext(SnackBarContext)

  const filterOptions = Object.values(FILTER_MAP_DENSITY_ENUM).map(item => ({
    label: item,
    value: item,
  }))

  useEffect(() => {
    processedMissionsMapRef.current = processedMissionsMap
  }, [processedMissionsMap])

  useEffect(() => {
    if (cityPlan.missions) {
      mergeNewMissionsData(cityPlan.missions)
      if (cityPlan.missions.length > 0 && filteredMissionsIds.length === 0) {
        setFilteredMissionsIds(
          cityPlan.missions.map(mission => String(mission.id)),
        )
        setIsFilterApplied(false)
      }
    }
  }, [cityPlan.missions])

  useEffect(() => {
    const savedSelectedIds = localStorage.getItem(localStorageKey)
    if (savedSelectedIds && Object.keys(processedMissionsMap).length > 0) {
      try {
        const selectedIds = JSON.parse(savedSelectedIds)

        const newVisibleOverlaysMap = {}
        Object.keys(processedMissionsMap).forEach(id => {
          newVisibleOverlaysMap[id] = false
        })

        selectedIds.forEach(id => {
          if (processedMissionsMap[id]) {
            newVisibleOverlaysMap[id] = true
          }
        })

        setVisibleOverlaysMap(newVisibleOverlaysMap)

        localStorage.removeItem(localStorageKey)
      } catch (error) {
        localStorage.removeItem(localStorageKey)
      }
    }
  }, [processedMissionsMap, localStorageKey])

  useEffect(() => {
    const visiblePostcodesIds = postcodesFromSearch.map(item => item.id)
    const newVisibleOverlaysMap = { ...visibleOverlaysMap }

    visiblePostcodesIds.forEach(id => {
      newVisibleOverlaysMap[id] = true
    })

    setVisibleOverlaysMap(newVisibleOverlaysMap)
  }, [postcodesFromSearch])

  const onMapInit = newMap => {
    if (!newMap || map) return
    setMap(newMap)
  }

  const onRefetchMissions = async () => {
    const selectedMissionsIds = Object.entries(visibleOverlaysMap).reduce(
      (acc, [id, isSelected]) => {
        if (isSelected) {
          acc.push(id)
        }
        return acc
      },
      [],
    )

    if (selectedMissionsIds.length > 0) {
      localStorage.setItem(localStorageKey, JSON.stringify(selectedMissionsIds))
    }

    await props.refetchMissions()
  }

  const mergeNewMissionsData = async rawMissions => {
    const { newMissionsMap, deletedMissionsIds } = getMissionsUpdateResult({
      receivedMissionsMap: convertArrayToHashMap(rawMissions, 'id'),
      existingMissionsMap: processedMissionsMap,
    })

    const mergedInitialOverlaysMap = mergeInitialOverlaysData({
      newData: getInitialOverlaysMapFromMissions(newMissionsMap, {
        isClient: isClient(),
      }),
      oldData: initialOverlaysMap,
      deletedIds: deletedMissionsIds,
    })

    const mergedMissionsMap = mergeMissionsData({
      newData: newMissionsMap,
      oldData: processedMissionsMap,
      deletedIds: deletedMissionsIds,
    })

    const savedSelectedIds = localStorage.getItem(localStorageKey)
    const hasSavedState = savedSelectedIds && savedSelectedIds.length > 0

    let mergedVisibleOverlaysMap
    if (hasSavedState) {
      mergedVisibleOverlaysMap = {}
      Object.keys(mergedMissionsMap).forEach(id => {
        mergedVisibleOverlaysMap[id] = false
      })
    } else {
      mergedVisibleOverlaysMap = { ...visibleOverlaysMap }
      Object.keys(mergedMissionsMap).forEach(id => {
        if (!(id in mergedVisibleOverlaysMap)) {
          mergedVisibleOverlaysMap[id] = true
        }
      })
    }

    setInitialOverlaysMap(mergedInitialOverlaysMap)
    setVisibleOverlaysMap(mergedVisibleOverlaysMap)

    const newProcessedMissionsMap = convertArrayToHashMap(
      Object.values(mergedMissionsMap),
      'id',
    )
    setProcessedMissionsMap(newProcessedMissionsMap)
    processedMissionsMapRef.current = newProcessedMissionsMap

    setInitialDataLoaded(true)

    updateMissionsWithAreaInfo(
      Object.values(newMissionsMap),
      Object.values(mergedMissionsMap),
    )
  }

  const updateMissionsWithAreaInfo = async (
    missionsWithoutAreaInfo,
    processedMissions,
  ) => {
    try {
      const missionsAreaDataMap = await getNumberOfHouseholdsAndDensityForMissions(
        {
          missions: missionsWithoutAreaInfo.filter(mission => mission.boundary),
          countryCode: props.countryCode,
        },
      )
      const relatedPostcodes = await getPostcodesForBoundaries({
        geometries: missionsWithoutAreaInfo.reduce((acc, mission) => {
          // Get auto name only if mission is not named
          if (!mission.label) {
            const { geometry } = getFeatureFromOverlay({
              countryCode: props.countryCode,
              boundary: mission.boundary,
            })
            acc.push(geometry)
          }
          return acc
        }, []),
        countryCode: props.countryCode,
      })

      const missions = mergeAreaDataToTheMission({
        missions: processedMissions,
        missionsAreaDataMap,
        relatedPostcodes,
      })

      setProcessedMissionsMap(convertArrayToHashMap(missions, 'id'))
    } catch (error) {
      setProcessedMissionsMap(convertArrayToHashMap(processedMissions, 'id'))
      console.error(error)
    }
  }

  const deleteUnstartedMissionsById = async (
    missionsToBeDeletedIds,
    shouldUpdate = true,
    modalContainer,
  ) => {
    if (props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually delete missions for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      const {
        missionsToDelete,
        isAnyBooked,
        missionsSpyCheckedInIds,
      } = getMissionsDeletionData(
        Object.values(processedMissionsMap),
        missionsToBeDeletedIds,
      )

      if (!missionsToDelete.length) return

      const payload = {
        unbookReason: unbookReason,
        missions: missionsToDelete.map(({ id }) => ({ id })),
      }

      if (!missionsToDelete.length) {
        return showReduxModal({
          title: `There is 0 non-started missions that can be deleted`,
          confirmLabel: `OK`,
          hideCancel: true,
          container: modalContainer,
        })
      }

      const infoText = getShowDeleteAllNonStartedModalText(
        isAnyBooked,
        missionsSpyCheckedInIds,
      )

      return new Promise(resolve => {
        showReduxModal({
          title:
            missionsToDelete.length === 1
              ? 'Delete 1 non-started mission'
              : `Delete ${missionsToDelete.length} non-started missions`,
          onConfirm: async () => {
            await apiClient.deleteMissions(payload)
            deleteMissionsFromState(payload.missions.map(({ id }) => id))

            resolve()
            if (shouldUpdate) {
              onRefetchMissions()
            }
          },
          children: isAnyBooked && (
            <div>
              {infoText}
              <InlineSelect
                label={'Reason'}
                name={'unbookMission'}
                value={unbookReason}
                options={UNBOOK_OPTIONS}
                onChange={(e, index, value) => setUnbookReason(value)}
                openType={'relative'}
              />
            </div>
          ),
          cancelLabel: 'Cancel',
          confirmLabel: 'Delete All',
          container: modalContainer,
        })
      })
    }
  }

  const updateMissionHandler = async missionInput => {
    const updateMissionResponse = await updateMissionNormalized({
      missionInput,
    })
    const updateMissionResult = await updateMissionResponse.json()
    return updateMissionResult.data.updateMission.mission
  }
  /**
   * Saves or updates existing mission with received data
   * @param {number} param.id If passed then mission will be updated if no - new mission will be created
   * @param {string} param.color Overlay's color
   * @param {array} param.boundary Mission's boundary
   * @param {date} param.date Mission's start date (week)
   *
   * @returns {object} Created or update mission
   *
   * @example
   * onOverlaySave({
   *  id: 1,
   *  color: "#000",
   *  boundary: [{ latitude: 1, longitude: 1 }, { latitude: 2, longitude: 2}, { latitude: 3, longitude: 3 }],
   *  date: DateObject
   * })
   */
  const onOverlaySave = async ({
    id,
    color,
    boundary,
    date,
    label,
    overlay,
    undoHandler,
  }) => {
    const editedMission = processedMissionsMapRef.current[id]
    const shouldProceed = await validateOverlaySave({
      boundary,
      mission: editedMission,
      date,
      showReduxModal,
    })

    if (!shouldProceed) {
      undoHandler()
      return editedMission
    }

    const { countryCode } = props
    const { cityPlanId } = props.match.params

    // Reuse the shape's existing name on saves that don't carry a new label
    // (colour, week, drag and vertex edits). Regenerating via createOverlayName
    // costs a PathFinder postcode lookup on every such save, and — because it
    // dedups against the shape's own entry — could even rename it ("#1") or
    // discard an in-progress typed label. Only generate a fresh name for a
    // genuinely unnamed shape (first save of a newly drawn polygon).
    // This mirrors the behaviour already used in BuilderMap.onOverlaySave.
    const existingName =
      (overlay.payload && overlay.payload.label) ||
      (editedMission && editedMission.label)

    const name =
      label && label.length > 0
        ? label
        : existingName && existingName.length > 0
        ? existingName
        : await createOverlayName({
            countryCode,
            boundary,
            renderedOverlays: Object.values(processedMissionsMap),
          })
    overlay.set('payload', { ...overlay.payload, label: name })

    // If mission already exists then update it
    if (id) {
      const updateMissionInput = {
        id,
        boundary,
        boundaryColour: color,
        dateTime: date
          ? formatToLocalDate(getEndOfWeek(new Date(date)))
          : undefined,
        label: name,
        isNotShown: false,
      }
      const updatedMission = await updateMissionHandler(updateMissionInput)

      mergeNewMissionsData(
        Object.values({
          ...processedMissionsMapRef.current,
          [updatedMission.id]: updatedMission,
        }),
      )
      return updatedMission
    }

    const createMissionInput = {
      cityPlanId: Number(cityPlanId),
      type: MISSION_ENUM_TYPES.LETTERBOX,
      dateTime: formatToLocalDate(getEndOfWeek(new Date())),
      // LB specifics
      boundary,
      boundaryColour: color,
      label: name,
    }

    const [data] = await createMissions({
      missions: [createMissionInput],
      campaignId: props.match.params.campaignId,
    })

    const timeOfDay = calculateTimeOfDay(
      data.dateTime,
      props.city.lunchCheckInTime,
      props.city.afternoonCheckInTime,
    )

    const mission = { ...data, timeOfDay }
    mergeNewMissionsData(
      Object.values({
        ...processedMissionsMapRef.current,
        [mission.id]: mission,
      }),
    )

    // Set new mission as visible by default
    setVisibleOverlaysMap(prev => ({ ...prev, [mission.id]: true }))
    if (isFilterApplied) {
      setFilteredMissionsIds(prev =>
        Array.from(new Set([...(prev || []), String(mission.id)])),
      )
    }
    return mission
  }
  // Get details rows that we want to render
  const detailsItemsData = getDetailsItems({
    missions: Object.values(processedMissionsMap),
  })
  // Get breadcrumbs items that we want to render
  const breadcrumbsData = getBreadcrumbs({
    campaign: props.campaign,
    cityPlanId: props.match.params.cityPlanId,
    campaignId: props.match.params.campaignId,
    city: props.city,
  })

  const onAreaSelect = selectedIds => {
    setVisibleOverlaysMap(prev => {
      const newState = { ...prev }
      Object.keys(newState).forEach(id => {
        newState[id] = false
      })
      selectedIds.forEach(id => {
        newState[id] = true
      })
      return newState
    })
    runSnackBar({
      type: 'success',
      msg: `Selected ${selectedIds.length} mission${
        selectedIds.length !== 1 ? 's' : ''
      } on map`,
    })
  }

  const handleCheckboxChange = missionId => {
    setVisibleOverlaysMap(prev => {
      const newState = {
        ...prev,
        [missionId]: !prev[missionId],
      }
      return newState
    })
  }

  const onTableDataUpdate = ({ displayedData }) => {
    const visibleIds = displayedData.map(({ id }) => String(id))

    const allMissionIds = Object.keys(processedMissionsMapRef.current || {})
    if (
      visibleIds.length === allMissionIds.length &&
      allMissionIds.every(id => visibleIds.includes(id))
    ) {
      setFilteredMissionsIds(allMissionIds)
      setIsFilterApplied(false)
    } else {
      setFilteredMissionsIds(visibleIds)
      setIsFilterApplied(true)
    }
  }

  const onRowDelete = async id => {
    if (props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually delete missions for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      const payload = {
        unbookReason: undefined,
        missions: [{ id }],
      }
      deleteMissionsFromState([id])
      await apiClient.deleteMissions(payload)
    }
  }

  const deleteMissionsFromState = missionsToBeDeletedIds => {
    const clone = { ...processedMissionsMap }
    missionsToBeDeletedIds.forEach(id => {
      delete clone[id]
    })

    mergeNewMissionsData(Object.values(clone))
  }

  /**
   * checks if all overlays selected
   * @returns {boolean} true if all overlays selected
   */
  const checkIfAllOverlaysSelected = () => {
    const missionIds =
      filteredMissionsIds.length > 0
        ? filteredMissionsIds
        : Object.keys(processedMissionsMapRef.current || {})
    return (
      missionIds.length > 0 && missionIds.every(id => visibleOverlaysMap[id])
    )
  }

  /**
   * Set visible missions overlays according to checkbox value
   * @param {boolean} value of checkbox
   */
  const toggleAllMissionsOverlaysVisiblity = (e, value) => {
    const missionIds =
      filteredMissionsIds.length > 0
        ? filteredMissionsIds
        : Object.keys(processedMissionsMapRef.current || {})
    const newVisibleOverlaysMap = { ...visibleOverlaysMap }

    missionIds.forEach(id => {
      newVisibleOverlaysMap[id] = value
    })

    setVisibleOverlaysMap(newVisibleOverlaysMap)
  }
  const onPostcodesUpdate = ({ activePostcodes }) => {
    setPostcodesFromSearch(activePostcodes)
  }

  const convertGeoJSONToBoundary = geometry => {
    if (!geometry || !geometry.coordinates) return null

    let coordinates
    if (geometry.type === 'MultiPolygon') {
      coordinates = geometry.coordinates[0][0]
    } else if (geometry.type === 'Polygon') {
      coordinates = geometry.coordinates[0]
    } else {
      return null
    }

    return coordinates.slice(0, -1).map(([longitude, latitude]) => ({
      latitude,
      longitude,
    }))
  }

  const onBulkCreateMissions = async (postcodes, onProgress) => {
    if (props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually create missions for self-serve campaigns.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
      return
    }

    const { cityPlanId, campaignId } = props.match.params
    const createdMissions = []
    const total = postcodes.length

    for (let i = 0; i < postcodes.length; i++) {
      const postcode = postcodes[i]
      const boundary = convertGeoJSONToBoundary(postcode.geometry)

      if (!boundary || boundary.length < 3) {
        console.warn(`Skipping postcode ${postcode.name}: invalid geometry`)
        onProgress({
          current: i + 1,
          total,
          text: `Skipped ${postcode.name} (invalid geometry)`,
        })
        continue
      }

      onProgress({
        current: i,
        total,
        text: `Creating mission for ${postcode.name}...`,
      })

      try {
        const createMissionInput = {
          cityPlanId: Number(cityPlanId),
          type: MISSION_ENUM_TYPES.LETTERBOX,
          dateTime: formatToLocalDate(getEndOfWeek(new Date())),
          boundary,
          boundaryColour: generateRandomColor(),
          label: postcode.name,
        }

        const [data] = await createMissions({
          missions: [createMissionInput],
          campaignId,
        })

        const timeOfDay = calculateTimeOfDay(
          data.dateTime,
          props.city.lunchCheckInTime,
          props.city.afternoonCheckInTime,
        )

        const mission = { ...data, timeOfDay }
        createdMissions.push(mission)

        onProgress({
          current: i + 1,
          total,
          text: `Created mission for ${postcode.name}`,
        })
      } catch (error) {
        console.error(`Failed to create mission for ${postcode.name}:`, error)
        onProgress({
          current: i + 1,
          total,
          text: `Failed to create mission for ${postcode.name}`,
        })
      }
    }

    if (createdMissions.length > 0) {
      mergeNewMissionsData(
        Object.values({
          ...processedMissionsMapRef.current,
          ...convertArrayToHashMap(createdMissions, 'id'),
        }),
      )

      const newVisibleOverlays = { ...visibleOverlaysMap }
      createdMissions.forEach(mission => {
        newVisibleOverlays[mission.id] = true
      })
      setVisibleOverlaysMap(newVisibleOverlays)

      if (isFilterApplied) {
        setFilteredMissionsIds(prev =>
          Array.from(
            new Set([...prev, ...createdMissions.map(m => String(m.id))]),
          ),
        )
      }

      runSnackBar({
        type: 'success',
        msg: `Successfully created ${createdMissions.length} mission${
          createdMissions.length !== 1 ? 's' : ''
        }`,
      })
    }

    return createdMissions
  }

  const onBulkPostcodesSelected = selectedPostcodes => {
    setPostcodesFromSearch(selectedPostcodes)
  }

  const showClearBtn = useMemo(() =>
    Object.values(processedMissionsMap).find(
      mission => mission.id && NON_STARTED_STATUSES.includes(mission.status),
    )
      ? true
      : false,
  )

  const getVisibleOverlaysMapForMap = () => {
    const result = {}
    const allMissionIds = Object.keys(processedMissionsMapRef.current || {})

    allMissionIds.forEach(id => {
      const isSelected = visibleOverlaysMap[id] === true
      const isInFilter = !isFilterApplied || filteredMissionsIds.includes(id)
      result[id] = isSelected && isInFilter
    })

    postcodesFromSearch.forEach(postcode => {
      result[postcode.id] = true
    })

    return result
  }

  const visibleOverlaysMapForMap = useMemo(() => {
    return getVisibleOverlaysMapForMap()
  }, [
    visibleOverlaysMap,
    filteredMissionsIds,
    isFilterApplied,
    postcodesFromSearch,
  ])

  const getFilteredAndSelectedMissions = () => {
    return Object.values(processedMissionsMapRef.current).filter(
      mission =>
        visibleOverlaysMap[mission.id] &&
        (filteredMissionsIds.length === 0 ||
          filteredMissionsIds.includes(String(mission.id))),
    )
  }

  const hasSelectedDraftMissions = useMemo(
    () =>
      authorization.isCityManager() &&
      Object.values(processedMissionsMap).some(
        mission =>
          visibleOverlaysMap[mission.id] &&
          mission.status === MISSION_STATUS_ENUM.DRAFT &&
          (filteredMissionsIds.length === 0 ||
            filteredMissionsIds.includes(String(mission.id))),
      ),
    [processedMissionsMap, visibleOverlaysMap, filteredMissionsIds],
  )

  const onBulkPublish = () => {
    const missionsToPublish = getFilteredAndSelectedMissions()

    onPublishDraftMissions({
      campaign: props.campaign,
      missions: missionsToPublish,
      showReduxModal,
      updateData: onRefetchMissions,
      isTeamLeaderEnabled: false,
      runSnackBar,
      hideReduxModal,
    })
  }

  const onBulkSetReadyToPublish = isReadyToPublish => () => {
    onSetDraftMissionsReadyToPublish({
      missions: getFilteredAndSelectedMissions(),
      isReadyToPublish,
      showReduxModal,
      updateData: onRefetchMissions,
      runSnackBar,
      hideReduxModal,
    })
  }

  const onBulkEdit = () => {
    if (props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually bulk edit missions for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      const missionsToEdit = getFilteredAndSelectedMissions()

      const text = missionsToEdit.some(mission => mission.canBeSpied)
        ? 'The missions would be removed from the spy shift if you change date or location'
        : null

      showReduxModal({
        title: `Edit ${missionsToEdit.length} missions`,
        children: (
          <Fragment>
            {text ? (
              <Typography
                align="center"
                style={{ marginBottom: 20, color: 'red' }}
              >
                {text}
              </Typography>
            ) : null}
            <BulkEditMissionModalBody
              missionsToEdit={missionsToEdit}
              onClose={onRefetchMissions}
              currencySign={currencySign}
            />
          </Fragment>
        ),
        hideButtons: true,
      })
    }
  }

  const onBulkDelete = async () => {
    if (props.campaign.isSelfServe) {
      handleConfirmationDialog({
        title: 'Restricted!',
        contentText: `You cannot manually bulk delete missions for self-serve campaigns. If you need to do this, please contact tech.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })
    } else {
      const missionsToDeleteIds = getFilteredAndSelectedMissions().map(
        mission => mission.id,
      )

      deleteUnstartedMissionsById(missionsToDeleteIds, true)
    }
  }

  const onBulkMarkerEdit = () => {
    const missionsToEdit = getFilteredAndSelectedMissions()

    const allowedStatuses = [
      MISSION_STATUS_ENUM.DRAFT,
      MISSION_STATUS_ENUM.AVAILABLE,
      MISSION_STATUS_ENUM.BOOKED,
    ]

    const { statuses, periodOfDay } = missionsToEdit.reduce(
      (acc, mission) => {
        acc.statuses.push(mission.status)

        const [date] = mission.dateTime.split('T')
        acc.periodOfDay.push(`${date}-${mission.timeOfDay}`)
        return acc
      },
      { statuses: [], periodOfDay: [] },
    )

    const allStatusesAllowed = statuses.every(status =>
      allowedStatuses.includes(status),
    )

    if (!allStatusesAllowed) {
      handleConfirmationDialog({
        title: 'Cannot be edited!',
        contentText: `Not all selected missions have allowed statuses (DRAFT, AVAILABLE, BOOKED).`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })

      return
    }

    if ([...new Set(periodOfDay)].length > 1) {
      handleConfirmationDialog({
        title: 'Cannot be edited!',
        contentText: `Not all selected missions have the same period of day (MORNING, LUNCH, AFTERNOON) and day.`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })

      return
    }

    setMissionsToSetMeetingPoint(missionsToEdit)
  }

  const onSingleMeetingPointEdit = ({ mission }) => {
    const allowedStatuses = [
      MISSION_STATUS_ENUM.DRAFT,
      MISSION_STATUS_ENUM.AVAILABLE,
      MISSION_STATUS_ENUM.BOOKED,
    ]

    if (!allowedStatuses.includes(mission.status)) {
      handleConfirmationDialog({
        title: 'Cannot be edited!',
        contentText: `Not all selected missions have allowed statuses (DRAFT, AVAILABLE, BOOKED).`,
        setConfirmDialogData,
        rightButtonLable: 'OK',
      })

      return
    }

    setMissionsToSetMeetingPoint([mission])
  }

  return (
    <HideWhenBlocked>
      {confirmDialogData.isOpen && <ConfirmDialog {...confirmDialogData} />}
      <SetMeetingPointModal
        missionsToEdit={missionsToSetMeetingPoint}
        city={props.city}
        countryCode={countryCode}
        isOpen={!!missionsToSetMeetingPoint.length}
        onClose={() => {
          setMissionsToSetMeetingPoint([])
        }}
        onRefetchMissions={onRefetchMissions}
      />
      <RosterViewWrapper>
        <LayoutDashboard>
          <BreadcrumbsRenderer
            icon={breadcrumbsData.icon}
            items={breadcrumbsData.items}
          />
          <PageTitle>Letterbox Missions</PageTitle>
          {!authorization.isSpy() && (
            <MissionsControls
              missions={Object.values(processedMissionsMap)}
              campaign={props.campaign}
              updateData={onRefetchMissions}
              isTeamLeaderEnabled={false}
            />
          )}
          <DetailsSection items={detailsItemsData} />
          {initialDataLoaded ? (
            <section>
              {!isClient() && !props.campaign.isSelfServe && (
                <Row style={{ marginBottom: '16px' }}>
                  <Col xs={12}>
                    <Typography
                      variant="subtitle1"
                      style={{ marginBottom: '8px', fontWeight: 600 }}
                    >
                      Bulk Postcode Search
                    </Typography>
                    <BulkPostcodeSearch
                      countryCode={props.countryCode}
                      onPostcodesSelected={onBulkPostcodesSelected}
                      onCreateMissions={onBulkCreateMissions}
                      disabled={false}
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col xs={4}>
                  <SelectDashboard
                    options={filterOptions}
                    value={selectedFilter}
                    onChange={(a, b, value) => {
                      setSelectedFilter(value)
                    }}
                    disabled={!densityFilterLoaded}
                  />
                </Col>
                <Col xs={8}>
                  <PostcodesSearch
                    countryCode={props.countryCode}
                    onUpdate={onPostcodesUpdate}
                  />
                </Col>
              </Row>

              <DrawMap
                onMapInit={onMapInit}
                onSave={onOverlaySave}
                initialOverlays={Object.values({
                  ...initialOverlaysMap,
                  ...convertArrayToHashMap(postcodesFromSearch, 'id'),
                })}
                mapOptions={{
                  center: {
                    lat: props.city.latitude,
                    lng: props.city.longitude,
                  },
                }}
                onDelete={(overlays, shouldUpdate, modalContainer) =>
                  deleteUnstartedMissionsById(
                    overlays.reduce(
                      (acc, { customId, canBeDeleted, isPostcode }) =>
                        canBeDeleted && !isPostcode ? [...acc, customId] : acc,
                      [],
                    ),
                    shouldUpdate,
                    modalContainer,
                  )
                }
                loading={false}
                hideMapControls={isClient() || props.campaign.isSelfServe}
                countryCode={props.countryCode}
                visibleOverlaysMap={visibleOverlaysMapForMap}
                mapControls={
                  showClearBtn
                    ? ['DRAW', 'SELECT_AREA', 'CLEAR_ALL']
                    : ['DRAW', 'SELECT_AREA']
                }
                clearAllLabel={'Delete non-started'}
                filter={selectedFilter}
                onFilterLoaded={setDensityFilterLoaded}
                onAreaSelect={onAreaSelect}
              />
              <Typography
                variant="caption"
                style={{
                  display: 'block',
                  marginTop: '8px',
                  marginBottom: '8px',
                  color: '#666',
                }}
              >
                Tip: Click the grid icon to draw a selection rectangle on the
                map and group nearby polygons for bulk editing.
              </Typography>
              <Grid container spacing={2}>
                <Grid item>
                  <BulkActions
                    onPublish={onBulkPublish}
                    onMarkReadyToPublish={
                      hasSelectedDraftMissions
                        ? onBulkSetReadyToPublish(true)
                        : null
                    }
                    onUnmarkReadyToPublish={
                      hasSelectedDraftMissions
                        ? onBulkSetReadyToPublish(false)
                        : null
                    }
                    onEdit={onBulkEdit}
                    onDelete={onBulkDelete}
                    onSetMarker={onBulkMarkerEdit}
                    disabled={!Object.keys(processedMissionsMap).length}
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={true}
                        checked={checkIfAllOverlaysSelected()}
                        onChange={toggleAllMissionsOverlaysVisiblity}
                      />
                    }
                    label="Select all missions"
                  />
                </Grid>
              </Grid>
              <LetterboxMissionsTable
                missions={Object.values(processedMissionsMap).map(mission => ({
                  ...mission,
                  city: props.city, // For BA link
                }))}
                campaign={props.campaign}
                onCheckboxChange={handleCheckboxChange}
                history={props.history}
                match={props.match}
                checkboxesMap={visibleOverlaysMap}
                onTableDataUpdate={onTableDataUpdate}
                onDelete={onRowDelete}
                onEditMeetingPoint={onSingleMeetingPointEdit}
                timezone={timezone}
              />
            </section>
          ) : (
            <LoadingIndicator />
          )}
        </LayoutDashboard>
      </RosterViewWrapper>
    </HideWhenBlocked>
  )
}

const mapDispatchToProps = {
  deleteMissions,
  showReduxModal,
  hideReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(LetterboxMissions)
